import React, { Component, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import textosJSON from "./textosContacto.json";


const ContactoExito = () => {
    const mobile = window.innerWidth < 1280;

    const location = useLocation();
    const idioma = location.pathname.split("/")[1]
    const texto = (nombre) => {
      return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    },[])
    return (
    <div 
        style={{
            marginTop: mobile?60:122,
            paddingTop: mobile?60:86,
            paddingBottom: mobile?100:212,
            paddingLeft: "10%",
            paddingRight: "10%",
            backgroundColor: "#ffffff",
            maxWidth: "100%"
        }}
    >
        <h1 className="contacto_exito_1">{texto("exito_1")}</h1>
        <p className="contacto_exito_2">{texto("exito_2")}</p>
        <Link to={"/" + idioma + "/home"}>
          <h3 className="contacto_exito_boton">{texto("exito_volver")}</h3>
        </Link>
    </div>
    );
}
 
export default ContactoExito;
